<template>
    <ValidationProvider :name="name" :rules="rules" class="validationWrapper">
        <div slot-scope="{ errors }">
            <span class="validationMessage">
                {{ errors[0] }}
            </span>
            <v-autocomplete
                v-if="type === 'autocomplete'"
                v-model="inputVal"
                :items="statesUS"
                :filter="customFilter"
                :hint="hint"
                :name="name"
                :label="label"
                :readonly="readonly"
                item-text="name"
                item-value="alpha2code"
                outlined
                dense
            ></v-autocomplete>

            <v-text-field
                v-if="mask !== '' && type === 'text'"
                :id="name"
                v-model="inputVal"
                v-mask="mask"
                :hint="hint"
                :name="name"
                :label="label"
                :readonly="readonly"
                :disabled="disabled"
                outlined
                dense
            ></v-text-field>
            <v-text-field
                v-if="mask === '' && type === 'text'"
                :id="name"
                v-model="inputVal"
                :hint="hint"
                :name="name"
                :label="label"
                outlined
                :readonly="readonly"
                :disabled="disabled"
                dense
            ></v-text-field>
        </div>
    </ValidationProvider>
</template>
<script>
import { ValidationProvider } from 'vee-validate'
import { mask } from 'vue-the-mask'
import statesUS from '~/util/statesUS.js'
export default {
    name: 'CustomInputField',
    components: {
        ValidationProvider
    },
    directives: {
        mask
    },
    props: {
        name: {
            type: String,
            required: true
        },
        hint: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        rules: {
            type: String,
            default: ''
        },
        mask: {
            type: String,
            default: ''
        },
        readonly: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'text'
        }
    },
    data() {
        return {
            inputVal: '',
            phoneMask: '(###) ###-####',
            statesUS
        }
    },
    watch: {
        inputVal(value) {
            this.$emit('input', value)
        },
        value(val) {
            if (val !== this.inputVal) {
                this.inputVal = val
            }
        }
    },
    mounted() {
        if (this.value) {
            this.inputVal = this.value
        }
    },
    methods: {
        customFilter(item, queryText, itemText) {
            // console.log(item)
            // console.log(queryText)
            // console.log(itemText)
            const textOne = item.name.toLowerCase()
            const textTwo = item.alpha2code.toLowerCase()
            const searchText = queryText.toLowerCase()

            return textOne.includes(searchText) || textTwo.includes(searchText)
        }
    }
}
</script>
